// API Configuration
const getApiUrl = () => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:3001';
  }
  
  // For production, use the environment variable or try to detect the backend URL
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // If no environment variable is set, try to construct the backend URL
  // This assumes the backend is running on the same domain with a different port or path
  const currentUrl = window.location.origin;
  
  // If the frontend is on a custom domain, assume backend is on the same domain but different port
  if (currentUrl.includes('localhost')) {
    return 'http://localhost:3001';
  } else {
    // For production deployments, you might want to use a different approach
    // This is a fallback - you should set REACT_APP_API_URL in production
    return `${currentUrl}:3001`;
  }
};

export const apiConfig = {
  baseURL: getApiUrl(),
  endpoints: {
    newsletter: {
      subscribe: '/api/newsletter/subscribe',
      health: '/api/newsletter/health'
    },
    health: '/health'
  }
};

// Helper function to get full API URL
export const getFullApiUrl = (endpoint) => {
  return `${apiConfig.baseURL}${endpoint}`;
};